<div class="services-container">
  <div class="page-top-banner">
    <div class="title">Liste des services actifs</div>
  </div>

  <div class="table-container mat-elevation-z8">
    <table mat-table class="default-table" [dataSource]="dataSource">

      <ng-container matColumnDef="nom">
        <th mat-header-cell *matHeaderCellDef>Nom du service</th>
        <td mat-cell *matCellDef="let row">{{ row.nom }}</td>
      </ng-container>

      <ng-container matColumnDef="nbClients">
        <th mat-header-cell *matHeaderCellDef>Nb clients</th>
        <td mat-cell *matCellDef="let row">{{ row.nbClients }}</td>
      </ng-container>

      <ng-container matColumnDef="metrics">
        <th mat-header-cell *matHeaderCellDef>Métriques</th>
        <td mat-cell *matCellDef="let row">{{ row.metrics }}</td>
      </ng-container>

      <ng-container matColumnDef="statut">
        <th mat-header-cell *matHeaderCellDef>Statut</th>
        <td mat-cell *matCellDef="let row">{{ row.statut }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button (click)="openDialog(row)">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['nom', 'nbClients', 'metrics', 'statut', 'actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['nom', 'nbClients', 'metrics', 'statut', 'actions']"></tr>
    </table>
  </div>
</div>